module.exports = __webpack_public_path__ + "media/images/outlook-e9300a5b1ce1e97a2df8afcbfc787b34.png";